import React, { useEffect, useState } from "react";
import { ItemsTypeProps } from "../interface/CommonInterface";
import { readAllcodeTypeApi } from "../../../../api/code/CodeApi";
import { useMutation } from "@tanstack/react-query";
import { ItemTypeInit } from "./init/TypeInit";
import { ItemTypeInterface } from "./interface/TypeInterface";

export const ItemsType = ( { types, setTypes, menuId, setMenuId } : ItemsTypeProps) => {

    const [itemTypeArr, setItemTypeArr] = useState<ItemTypeInterface[] | []>([ItemTypeInit]);

    const readAllcodeTypeApiMutate = useMutation({
        mutationFn: () => readAllcodeTypeApi({menuId : menuId}),
        onSuccess: res => {
            if (res.data.code === "0000") {
                setItemTypeArr(res.data.result);
                setTypes(res.data.result[0])
            } else {
                alert("서비스 오류가 있습니다.")
                return;
            }
        },
        onError: res => {
            alert(res)
        }
    });

    useEffect(()=>{
        readAllcodeTypeApiMutate.mutate();
    },[menuId])

    return (
        <>
            <div className="items_boxes_outer">
                <div className="item_box1">
                    <div className="fiter_top">
                        <h3 className="filter_heading">항목 유형</h3>
                        <div className="filter_toolbar">
                            <select className="form-select w-150px" value={menuId} onChange={(e) => setMenuId(Number(e.target.value))}>
                                <option value={1}>비연동 항목</option>
                                <option value={2}>CRM 항목</option>
                            </select>
                        </div>
                    </div>
                    <ul className="list_items">
                        {itemTypeArr.map((item: any) => (
                            <li
                                key={item.codeTypeId}
                                className={types.codeTypeId === item.codeTypeId ? "active" : ""}
                            >
                                <a onClick={() => setTypes(item)}>
                                    {item.codeTypeName}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
}